document.addEventListener('DOMContentLoaded', function(){
        iniciarApp();
});

function iniciarApp() {
    navegacionFija();
    crearGaleria();
    scrollNav(); // en reealidad esta demas pq ya puse en globales el scroll beahvior smooth
}


function navegacionFija() {
    const barra = document.querySelector('.header');
    const sobreFestival = document.querySelector('.sobre-festival');
    const body = document.querySelector('body')

    window.addEventListener('scroll', function() {
        if( sobreFestival.getBoundingClientRect().bottom < 0 ) {
            barra.classList.add('fijo');
            body.classList.add('body-scroll');
        } else {
            barra.classList.remove('fijo');
            body.classList.remove('body-scroll');
        }
    });


}

function scrollNav() { 
    
    const enlaces = document.querySelectorAll('.navegacion-principal a');
    
    enlaces.forEach( enlace => {
        enlace.addEventListener('click', function(e) {

           // e.preventDefault(); //prevengo que se comporte de forma brusca el scroll pq esta así de forma predertminada

            const seccionScroll = e.target.attributes.href.value; //aca configuro post sacar la config preeestablecida de scroll
            const seccion = document.querySelector(seccionScroll);
            seccion.scrollIntoview({ behavior: "smooth"});
        });
    });
}


function crearGaleria() {
    const galeria = document.querySelector('.galeria-imagenes');

    for(let i = 1; i<= 12; i++) {
        const imagen = document.createElement('picture');

        imagen.innerHTML = `
        <img loading="lazy" width="200" height="300" src="src/img/thumb/${i}.jpg" alt="imagen galería">
        <source srcset="buil/img/thumb/${i}.webp" type="image/webp">
        <source srcset="buil/img/thumb/${i}.avif" type="image/avif">
        `;


        imagen.onclick = function() {
            mostrarImagen(i);
        }

        


        galeria.appendChild(imagen);
    }


}

function mostrarImagen(id) {
    const imagen = document.createElement('picture');

        imagen.innerHTML = `
        <img loading="lazy" width="200" height="300" src="src/img/grande/${id}.jpg" alt="imagen galería">
        <source srcset="buil/img/grande/${id}.webp" type="image/webp">
        <source srcset="buil/img/grande/${id}.avif" type="image/avif">
        `;

        //Crea el Overlay con la imagen
        const overlay = document.createElement('DIV');
        overlay.appendChild(imagen);
        overlay.classList.add('overlay'); 
        overlay.onclick = function() {
            const body = document.querySelector('body');
            body.classList.remove('fijar-body');
            overlay.remove();
        }

        //Boton para cerrar el Modal
        const cerrarModal = document.createElement('P');
        cerrarModal.textContent = 'X';
        cerrarModal.classList.add('btn-cerrar');
        cerrarModal.onclick = function() {
            const body = document.querySelector('body');
            body.classList.remove('fijar-body');
            overlay.remove();
        }

        overlay.appendChild(cerrarModal);

        //Añadirlo al HTML
        const body = document.querySelector('body');
        body.appendChild(overlay);
        body.classList.add('fijar-body');

     }